module.exports = __webpack_public_path__ + "static/media/051.90567a3b.png";